/* @flow */
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import ButtonGroup from 'components/ButtonGroup/ButtonGroup';
import navigation from 'services/NavigationService.js';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import UserStore from 'stores/UserStore';

import styles from './FormControls.module.scss';

export type FormControlsProps = {
  form: any,
  controls?: any,
  buttonText?: string,
  showSaveBtn?: boolean,
  disabled?: boolean,
};

type InjectedProps = {
  userStore: UserStore,
} & TranslatorProps;

@translate()
@inject('userStore')
@observer
export default class FormControls extends ComponentWithInjectedProps<
  FormControlsProps,
  {},
  InjectedProps
> {
  render() {
    const {
      controls,
      showSaveBtn,
      form,
      buttonText,
      disabled,
      t,
      userStore: { isReadOnly },
    } = this.props;

    return (
      <ButtonGroup>
        {(!controls || controls.onClear) && (
          <Button
            color="secondary"
            variant="contained"
            label="cancel"
            onClick={() => navigation.goBack()}
          >
            {t('general:actions.cancel')}
          </Button>
        )}
        <div className={styles['form-controls-btn-right']}>
          {showSaveBtn && (
            <Button
              type="submit"
              color="primary"
              variant="contained"
              className={styles['form-controls-save-btn']}
              onClick={e => {
                if (form) {
                  form.add({ name: 'clicked', value: 'save' });
                  form.onSubmit(e);
                }
              }}
            >
              {t('general:actions.save')}
            </Button>
          )}

          {(!controls || controls.onSubmit) && (
            <Button
              type="submit"
              color="primary"
              variant="contained"
              onClick={e => {
                if (form) {
                  form.add({ name: 'clicked', value: 'invite' });
                  form.onSubmit(e);
                }
              }}
              disabled={isReadOnly || disabled}
            >
              {buttonText || t('general:actions.send')}
            </Button>
          )}
        </div>
      </ButtonGroup>
    );
  }
}
